<template>
  <v-container>

    <v-layout align-center column fill-heigh justify-center>
      <v-card class="pa-5" style="max-width: 960px;">
        <v-flex md12>


          <v-card-text class="text-xs-right pb-1 pt-1">Ректору Российского химико-технологического</v-card-text>
          <v-card-text class="text-xs-right  pb-1 pt-1 ">университета имени Д.И. Менделеева</v-card-text>
          <v-card-text class="text-xs-right  pb-1 pt-1 ">Мажуге Александру Георгиевичу</v-card-text>

          <v-card-text class="text-xs-center  pb-5 pt-5 "><strong>Ходатайство о подаче заявки на создание
            диссертационного
            совета</strong>
          </v-card-text>
          <v-layout row wrap class="pb-2 pt-2">
            <v-flex md12>
              <v-autocomplete
                class="mr-3 ml-3"
                outline
                :loading="loaders.departments.status"
                :error="hasError('departments')"
                :error-messages="getError('departments')"
                :items="selectors.department.items"
                :item-disabled="selectors.department.disabled"
                no-data-text="Нет данных"
                label="Подразделение"
                v-model="value.departments"
                multiple
                :disabled=disabled
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-card-text class="text-xs-justify pb-1 pt-1 ">
            РХТУ им. Д.И. Менлелеева в соответствии с Положением о присуждении ученых степеней в федеральном
            государственном бюджетном образовательном учреждения высшего образования
            «Российский химико-технологический университет имени Д.И. Менделеева» и
            Положением о диссертационном совете федерального государственного бюджетного
            образовательного учреждения высшего образования «Российский химико-технологический
            университет имени Д.И. Менделеева» ходатайствует о разрешении подачи заявки на создание
            диссертационного совета и использование личного кабинета в системе самостоятельного
            присуждения ученых степеней РХТУ им. Д.И. Менлелеева.
          </v-card-text>
<!--          <v-card-text class="text-xs-left pb-1 pt-1">РХТУ им. Д.И. Менделеева в соответствии с Положением о присуждении ученых степеней в-->
<!--            федеральном государственном-->
<!--          </v-card-text>-->
<!--          <v-card-text class="text-xs-left pb-1 pt-1"> бюджетном образовательном учреждения высшего-->
<!--            образования «Российский химико-технологический-->
<!--          </v-card-text>-->
<!--          <v-card-text class="text-xs-left pb-1 pt-1"> университет имени Д.И. Менделеева» и-->
<!--            Положением о диссертационном совете федерального-->
<!--          </v-card-text>-->
<!--          <v-card-text class="text-xs-left pb-1 pt-1">государственного бюджетного образовательного-->
<!--            учреждения высшего образования-->
<!--          </v-card-text>-->
<!--          <v-card-text class="text-xs-left pb-1 pt-1">«Российский химико-технологический университет имени-->
<!--            Д.И. Менделеева»-->
<!--          </v-card-text>-->
<!--          <v-card-text class="text-xs-left pb-1 pt-1">ходатайствует о разрешении подачи заявки на создание-->
<!--            диссертационного совета и использование-->
<!--          </v-card-text>-->
<!--          <v-card-text class="text-xs-left pb-1 pt-1 ">личного кабинета в системе самостоятельного присуждения ученых-->
<!--            степеней РХТУ им. Д.И.Менделеева.-->
<!--          </v-card-text>-->
          <v-layout row wrap class=" pb-1 pt-3">
            <v-flex md5>
              <v-card-text class="text-xs-justify ">Лицо, ответственное за работу в системе</v-card-text>
            </v-flex>
            <v-flex md7>
              <v-autocomplete
                ref="responsible"
                class="mr-3 ml-3"
                :loading="loaders.responsible.status"
                outline
                :error="hasError('responsible')"
                :error-messages="getError('responsible')"
                :items="selectors.responsible"
                no-data-text="Нет данных"
                label="Сотрудник"
                v-model="value.responsible"
                :disabled=disabled
              ></v-autocomplete>
            </v-flex>
          </v-layout>


          <v-card-text class="text-xs-justify pb-1 pt-1">Планируется создание постоянно действующего диссертационного
            совета по научной специальности (научным специальностям) отрасли науки (отраслям науки)
          </v-card-text>

          <template v-for="(str, index) in value.specialities">

            <v-layout row wrap class=" pb-1 pt-3">

              <v-flex md5>
                <v-autocomplete
                  class="mr-3 ml-3"
                  outline
                  :error="getErrorArray('specialities')"
                  :error-messages="getErrorArrayField('specialities','speciality')"
                  :items="selectors.speciality"
                  no-data-text="Нет данных"
                  label="Научная специальность"
                  v-model="value.specialities[index].speciality"
                  :disabled=disabled
                  :item-text=text
                  :item-value=text
                ></v-autocomplete>
              </v-flex>
              <v-flex md5>
                <v-autocomplete
                  class="mr-3 ml-3"
                  outline
                  :error="getErrorArray('specialities')"
                  :error-messages="getErrorArrayField('specialities','branch')"
                  :items="selectors.branch"
                  no-data-text="Нет данных"
                  label="Отрасли науки"
                  v-model="value.specialities[index].branch"
                  :disabled=disabled
                ></v-autocomplete>
              </v-flex>

              <v-flex md1>
                <v-btn v-if=" value.specialities.length > 1 " icon @click="deleteData(index)" :disabled=disabled >
                  <v-icon class="material-icons">
                    clear
                  </v-icon>
                </v-btn>
<!--                <v-btn v-else icon @click="deleteData(index)"  >-->
<!--                  <v-icon class="material-icons">-->
<!--                    clear-->
<!--                  </v-icon>-->
<!--                </v-btn>-->
              </v-flex>

              <v-flex md1>
                <v-btn icon @click="addData" v-if=" index ===0" class="primary" :disabled=disabled>
                  <v-icon class="material-icons">
                    add
                  </v-icon>
                </v-btn>
              </v-flex>

            </v-layout>
          </template>
          <v-text-field
            class="mx-3 mt-5 mb-1"
            label="Должность рук,наименование структурного подразделения, ученое звание,степень,ФИО"
            outline
            v-model="user"
            readonly
          ></v-text-field>

        </v-flex>

        <v-alert
          :value="alert"
          color="green"
          dark
          border="top"
          icon="mdi-home"
          transition="scale-transition"
        >
          Заявка успешно создана
        </v-alert>
        <v-btn class="primary" @click="apply" :disabled=disabled>Подать заявку</v-btn>
        <v-btn class="primary" @click="recall" :disabled=!disabled>Отозвать заявку</v-btn>
        <v-btn class="primary" @click="printPDF" :disabled=generatePdf>
          <span v-if="!show_loadind">
            Сформировать PDF
          </span>
          <span v-else style="padding-left: 65px; width: 149px; align-content: center; text-align: center;">
            <semipolar-spinner
              :animation-duration="2000"
              :size="20"
              color="#1935ff"
            />
          </span>
        </v-btn>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
    import urlsW from "../urlsW.js"
  import urlsU from "../urlsU.js"
  import UserDataFormMixin from '../../../mixins/UserDataFormMixin'
  import urls from "../urls.js"
  import {makeGetRequest, makeManagerUrl, makePostRequest} from "../../../helper";
  import selectors from "../selectors";
  import user from "../../../store/modules/user";
  import {SemipolarSpinner} from 'epic-spinners'

  export default {
    name: "ApplicationDiss",
    components: {SemipolarSpinner},
    mixins: [UserDataFormMixin],
    props: {
      id: Number,
      departments: String,
      responsible: String,
    },
    data() {
      return {
        URL_CREATE: makeManagerUrl(urls.getUrl('admin|petition|petition|petition_create_council-list', 'create')),
        URL_UPDATE: makeManagerUrl(urls.getUrl('admin|petition|petition|petition_create_council-detail', 'update')),
        user: "Должность,наимен струк подр, уч зв, степень,ФИО",
        answer: 0,
        loaders: {
          responsible: {
              status: true,
              handler: () => this.load(this, urlsW.getUrl('selectors|employee|worker', 'get'))
          },
          departments: {
              status: true,
              handler: () => {
                  this.getChoices(
                      // educational-
                    urlsW.getUrl('selectors|department-educational-uid', 'get').replace('<organization_id>', '1'),
                  ).then(choices => {
                    this.selectors.department.items = choices;
                    this.getChoices(
                      urlsW.getUrl('department|self-pps-position-department', 'get')
                    ).then(json => {
                      this.value.departments.push(json.uid);
                      this.selectors.department.self = json.uid;
                      // this.selectors.department.items.find((item) => json.uid === item.value).disabled = true
                      this.loaders.departments.status = false;
                    });
                  });
              }
          },
          user: {
              status: true,
              handler: () => {
                makeGetRequest(
                    urlsW.getUrl('self_worker-title', 'title')
                ).then(resp => resp.json())
                .then(json => {
                    this.user = json.title
                });
              }
          }
        },
        selectors: {
          department: {
              items: [],
              max: 3,
              self: null,
              disabled: (item) => {
                  if(this.selectors.department.self === item.value)
                      return true;
                  else if(this.value.departments.indexOf(item.value) !== -1)
                      return false;
                  else if(this.value.departments.length >= this.selectors.department.max)
                      return true;
                  else
                      return false;
              }
          },
          responsible: [],
          speciality: selectors.speciality,
          branch: selectors.branch,
        },
        alert: false,
        disabled: false,
        value: {
          specialities: [
            {
              speciality: null,
              branch: null
            },
          ],
          departments: [],
          responsible: [],
        },
        generatePdf: true,
        show_loadind: false,
      }
    },

    methods: {
      allowed(urlname, action) {
        return urls.getUrlAllowed(urlname, action)
      },
      download(content, fileName, contentType) {
        var a = document.createElement("a");
        a.href = URL.createObjectURL(content);
        a.download = fileName;
        a.click();
      },
      addData() {
        if(this.value.specialities.length < 3)
        this.value.specialities.push(
          {
            speciality: null, branch: null
          })
      },
      recall(){
        let url = urls.getUrl('admin|petition|petition|petition_create_council-recall',"recall").replace('<id>', this.answer)
        let status = false;
        let data = {}
        // console.log(data);
        makePostRequest(url, data,"PATCH")
          .then(resp => {
            if(resp.ok) {
              status = false;
            }
            return resp.json();
          })
          .then(json => {
            if(json['changed']){
                this.disabled = false;
                this.generatePdf = true;
                this.$set(this.value, 'specialities', [
                    {
                        speciality: null,
                        branch: null
                    },
                ]);
                this.value.responsible = [];
                this.value.departments = [];
                this.answer = 0;
            }
          });
      },
      getUserData(){
        makeGetRequest(
          urls.getUrl('admin|petition|petition|petition_create_council-actual', 'actual'),
        ).then(resp => resp.json())
          .then(json => {
            if(json.existed){
              let RealData= json.object
              for (var key in  RealData.departments) {
                  var dep = this.value.departments.find(departments => departments.value === RealData.departments[key].uid);
                  if(dep !== undefined)
                    this.value.departments.push({"value":RealData.departments[key].uid});
              }
              this.value.specialities = RealData.specialities;
              this.value.responsible = RealData.responsible;
              this.disabled = true;
              this.generatePdf = false;
              this.answer = RealData.id
            }
          })
      },
      printPDF(){
        this.generatePdf = true;
        this.show_loadind = true;
        let status = true;
        const type = "application/pdf";
        const name = 'file.pdf';
        makeGetRequest(
          urls.getUrl('admin|petition|petition|petition_create_council-make-file', 'make_file').replace('<id>', this.answer),
        ) .then(resp => {
          if (!resp.ok) {
            status = false;
          }
          return resp.blob();
        }) .then(blob => {
          this.download(blob, name, type);
          this.generatePdf = false;
          this.show_loadind = false;
        })

      },
      deleteData(idx) {
        if(this.value.specialities.length > 1)
          this.value.specialities.splice(idx, 1);
      },
      text: item => item.code + ' - ' + item.name,
      apply() {
        let url = this.getCreateUrl();
        let depart = this.value.departments;
        let sendData = Object.assign({},this.value);
        sendData.departments = [];
        for (var key in depart) {
          sendData.departments.push({"departmentrelationmodel": depart[key]})
        }
        let data = sendData;
        let status = true;
        makePostRequest(url, data)
          .then(resp => {
            if (!resp.ok) {
              status = false;
            }
            return resp.json();
          })
          .then(json => {
            if (status) {
              this.alert = true;
              this.disabled = true;
              this.generatePdf = false;
              this.answer = json.id
            } else {
                this.receiveErrors(json);
            }
          })
      },
      load: function(app, url) {
        if(url === null) {
          app.loaders.responsible.status = false;
          return;
        }
        makeGetRequest(url)
          .then(resp => resp.json())
          .then(json => {
            let users = [];
            let results = [];
            let next_url = null;
            if(json['next'] !== null)
              next_url = url.split('?')[0] + '?' + json['next'].split('?')[1];
            for(let i in json['results']){
              users.push(json['results'][i].value);
              results.push(Object.assign({}, json['results'][i]));
            }
            makePostRequest(
              urlsU.getUrl('users|user|fio', 'post'),
              {'uids': users}
            )
              .then(resp => resp.json())
              .then(json => {
                for(let i in json){
                  let replaced = results.find((item) => item.value === json[i].value);
                  replaced.text =  json[i].text + ' (' + replaced.text + ')';
                  app.selectors.responsible.push(replaced)
                }
                results = null;
                app.load(app, next_url);
              });
          });
      },
    },
    created() {

      this.loaders.responsible.handler();
      this.loaders.departments.handler();
      this.loaders.user.handler();
      this.getUserData();
      this.$store.commit('mainpage/changeTitle', 'Ходатайство о подачи заявки на создание диссертационного совета');
    },
    beforeRouteEnter(to, from, next){
        makeGetRequest(urls.getUrl('admin|petition|checker|petition|self-local-admin', 'get'))
            .then((resp) => {
                return resp.json();
            }).then((json) => {
            let local_admin = json['allowed'];
            if(local_admin) {
              next({name: 'ListDiss', query: {local_admin: local_admin}});
            }else{
              next()
            }
        });

    },
  }

</script>

<style scoped>

</style>
